import React from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Label from '@/components/form/Label/Label';
import { useFormContext } from 'react-hook-form';
import TextArea from '@/components/form/Textarea/TextArea';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';
import RadioGroup from '@/components/form/RadioGroup/RadioGroup';
import Radio from '@/components/form/Radio/Radio';
import FeedbackError from '@/components/form/FeedbackError/FeedbackError';
import { useTranslations } from 'next-intl';

export interface FormAdditionalInformationProps {}

const FormAdditionalInformation = ({ ...props }: FormAdditionalInformationProps) => {
  const t = useTranslations('FormCrieSeuRoteiro');

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<FormCreateJourneyDataType>();

  return (
    <Fieldset size="lg" align="center">
      <legend>{t('Incluir informação adicional')}?</legend>
      <FieldGroup>
        <Label htmlFor="message">{t('Informação adicional')}</Label>
        <TextArea
          id="message"
          error={errors.message?.message}
          rows={5}
          maxLength={1000}
          helperText={`${t('Adicione outros detalhes ou dúvidas que tenha')}.`}
          showCounter
          {...register('message')}
        />
      </FieldGroup>
      <RadioGroup label={`${t('A passagem aérea já foi comprada')}?`}>
        <Radio label={t('Sim')} value="sim" {...register('purchasedFlight')} />
        <Radio label={t('Não')} value="não" {...register('purchasedFlight')} />
        {!watch('purchasedFlight') && errors.purchasedFlight?.message && (
          <FeedbackError error={errors.purchasedFlight?.message} />
        )}
      </RadioGroup>
    </Fieldset>
  );
};

export default FormAdditionalInformation;
